export default {
    name: "ReferralForm",

    props: ['selectedMembers'],

    data() {
        return {
            disabled: false,
            loading: false,
        };
    },

    components: {},

    computed: {
        
    },

    methods: {
        onSubmit() {
            let form = $(this.$refs.form);
            let self = this;
            self.toggleDisable();

            $.ajax({
                type: "POST",
                url: `${form.attr("action")}`,
                data: form.serialize()  + '&selectedMembers=' + JSON.stringify(self.selectedMembers),
                success: function(response) {
                    location.reload(); 
                },
                error: function(response) {
                    self.toggleDisable();
                    alert('An error occured. Please contact administrator');
                }
            });
        },

        toggleDisable() {
            this.disabled = !this.disabled;
            this.loading = !this.loading;
        }
    },

    created() {},

    mounted() {
        console.info(`loading ${this.$options.name}`);
    }
};



// WEBPACK FOOTER //
// ./js/components/ReferralForm.js